/** Türkçe arama için normalleştirme: küçük harf (tr), aksan temizleme, ı→i, trim. */
export const normalizeTr = (s?: string | null): string =>
  (s ?? '')
    .toLocaleLowerCase('tr')
    .trim()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ı/g, 'i');
